module.exports = __webpack_public_path__ + "img/platform_sjck.b4f7a537.jpg";